import { useCallback } from 'react'
import { Trans } from 'react-i18next'
import { useBoolean } from 'react-use'
import { v4 as uuid4 } from 'uuid'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import {
  VariableResultColumnData,
  VariableResultCurrentListItem,
  VariableSelectFeatureFlag,
} from '@makyoapp/makyo-common'
import { SingleCell16 } from '@makyoapp/makyo-icon/icon'

import { VariableColumnDataBody } from './VariableColumnData'
import { VariableWrapper } from './VariableWrapper'

export default function VariableCurrentListItem({
  id,
  onChange,
  columnTypes = Object.values(ColumnTypes),
  tableId,
  excludeColIds = [],
}: {
  id?: string
  onChange?: (newValue: VariableResultCurrentListItem) => void
  columnTypes?: ColumnTypes[]
  tableId?: string
  excludeColIds?: string[]
}) {
  const [show, setShow] = useBoolean(false)
  const [us, setUs] = useBoolean(false)

  if (!tableId) return null

  return (
    <VariableWrapper
      id={id}
      show={show}
      setShow={setShow}
      title={<Trans>This Item</Trans>}
      icon={<SingleCell16 width={16} height={16} />}
      defaultHeight={false}
    >
      <VariableCurrentListItemBody
        value={{
          id: uuid4(),
          flag: VariableSelectFeatureFlag.CurrentListItem,
          col: undefined,
          userSpecific: false,
        }}
        setShow={setShow}
        userSpecific={us}
        setUserSpecific={setUs}
        columnTypes={columnTypes}
        onChange={onChange}
        tableId={tableId}
        excludeColIds={excludeColIds}
      />
    </VariableWrapper>
  )
}

export function VariableCurrentListItemBody({
  onChange,
  columnTypes = Object.values(ColumnTypes),
  setShow,
  value,
  userSpecific,
  setUserSpecific,
  tableId,
  excludeColIds = [],
}: {
  onChange?: (newValue: VariableResultCurrentListItem) => void
  columnTypes?: ColumnTypes[]
  setShow: (nextShow: boolean) => void
  value: VariableResultCurrentListItem
  userSpecific: boolean
  setUserSpecific: (next: boolean) => void
  tableId?: string
  excludeColIds?: string[]
}) {
  const handleChange = useCallback(
    (v: VariableResultColumnData) => {
      const val: VariableResultCurrentListItem = {
        id: v.id,
        flag: VariableSelectFeatureFlag.CurrentListItem,
        col: v.col,
        userSpecific: v.userSpecific,
      }
      onChange?.(val)
    },
    [onChange]
  )
  return (
    <VariableColumnDataBody
      tableId={tableId}
      setShow={setShow}
      userSpecific={userSpecific}
      setUserSpecific={setUserSpecific}
      columnTypes={columnTypes}
      value={value as unknown as VariableResultColumnData}
      onChange={handleChange}
      noTbl
      excludeColIds={excludeColIds}
    />
  )
}
